import { render } from "./OrderReturn.vue?vue&type=template&id=21634c18&scoped=true"
import script from "./OrderReturn.vue?vue&type=script&lang=js"
export * from "./OrderReturn.vue?vue&type=script&lang=js"

import "./OrderReturn.vue?vue&type=style&index=0&id=21634c18&scoped=true&lang=scss"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21634c18"]])

export default __exports__